import * as yup from 'yup';

export const blockUnblockFormSchema = yup.object().shape({
  reason: yup.string().max(255).required().default(''),
});
